import { Injectable } from '@angular/core';
import * as debug from './debug.service';
import { LocalDb, IProfile } from '../utils/local-db';
import { IUserProfile } from '../responses/iuser-profile';
import { IMenu } from '../responses/imenu';
import { fallbackMenu } from '../utils/utility.common';

@Injectable({ providedIn: 'root' })
export class ProfileDbService extends LocalDb {

	// // Profile Db is not intended for multi-user.. All will be cleared on Log-off
	constructor() {
		super();
	}

	async getProfileRow(isLoggedIn: boolean, caller: string): Promise<IProfile> {

		const isGuest = !isLoggedIn;
		const row = await this.profiles
			.where('isGuest')
			.equalsIgnoreCase(isGuest.toString())
			// .orderBy('stamp')
			.last();

		return Promise.resolve(row);

	}

	getProfileData(row: IProfile) {

		const profile = JSON.parse(row.data);
		const response: IUserProfile = profile;

		return response;

	}

	async getLocalProfile(isLoggedIn: boolean, caller: string): Promise<IUserProfile> {
		// // return Promise.resolve(fallbackMenu);
		// if (!!this.userProfile) {
		//     debug.log(`016 menuService: Profile data found. reusing menuService.userProfile.`);
		//     return Promise.resolve(this.userProfile);
		// }
		let response: IUserProfile;

		const row = await this.getProfileRow(isLoggedIn, caller);

		if (!!row && row.data) {

			response = this.getProfileData(row);

			debug.log(`${caller}->ProfileDbService.getLocalProfile isLoggedIn: ${isLoggedIn}. Profile data found: `, response);

			return Promise.resolve(response);
		}

		debug.log(`${caller}->ProfileDbService.getLocalProfile isLoggedIn: ${isLoggedIn}'. Profile data not found. Returning fallbackMenu`, fallbackMenu);

		return Promise.resolve(fallbackMenu);

	}

	async getEmail(): Promise<string> {
		// return Promise.resolve('');
		const row = await this.getLocalProfile(true, 'getEmail');

		if (!!row) {

			return Promise.resolve(row.email);

		}

		return Promise.resolve('');

	}

	async getMenus(isLoggedIn: boolean, caller: string = ''): Promise<Array<IMenu>> {

		const profile = await this.getLocalProfile(isLoggedIn, caller);

		if (!profile) { Promise.resolve(fallbackMenu.menus); }

		return Promise.resolve(profile.menus);
	}

	async store(isLoggedIn: boolean, profile: IUserProfile, caller: string): Promise<string> {

		debug.log(`${caller}->ProfileDbService.store isLoggedIn: ${isLoggedIn} storing profile:`, profile);
		// return Promise.resolve('');

		if (!profile) {

			debug.log(`${caller}->ProfileDbService.store isLoggedIn: ${isLoggedIn} profile is empty!!! profile Not saved!`);

			return Promise.resolve('');
		}

		if (!profile.id) {

			debug.log(`${caller}->ProfileDbService.store: ${isLoggedIn} profile.id is empty!!! profile Not saved!`);

			return Promise.resolve('');
		}

		const profileId = profile.id;
		// const row = this.profiles.where('guid').equals(guid).first();
		const isGuest = (!isLoggedIn).toString();
		const clonedProfile = { ...profile };
		const data = JSON.stringify(clonedProfile);
		const newItem: IProfile = { id: profileId, isGuest, data };

		debug.log(`${caller}->ProfileDbService.store isLoggedIn: ${isLoggedIn} saving!! newItem:`, newItem);

		const saved = await this.profiles.put(newItem);

		debug.log(`${caller}->ProfileDbService.store isLoggedIn: ${isLoggedIn} saved!!! added: ${saved}`);

		return Promise.resolve(saved.toString());

	}

	async deleteNonGuestUsers() {

		await this.profiles.where('isGuest').equals('false').delete();

	}
}
